import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../common/DataTable';
import StatusBadge from '../common/StatusBadge';
import { formatDate } from '../../utils/formatters';
import './ApplicationList.css';

const ApplicationList = ({ applications = [], loading }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const filteredApplications = applications.filter(app => {
    const matchesSearch = app.applicantName?.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          app.applicantEmail?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter ? app.status === statusFilter : true;
    return matchesSearch && matchesStatus;
  });

  const columns = [
    { 
      header: 'Applicant', 
      accessor: 'applicantName',
      render: (row) => (
        <div>
          <div 
            className="application-link" 
            onClick={() => navigate(`/applications/${row.id}`)}
          >
            {row.applicantName || 'Pending Applicant'}
          </div>
          <div className="applicant-email">{row.applicantEmail}</div>
        </div>
      )
    },
    { header: 'Property', accessor: 'propertyAddress' },
    { header: 'Status', accessor: 'status', render: (row) => <StatusBadge status={row.status} /> },
    { header: 'Created', accessor: 'createdAt', render: (row) => formatDate(row.createdAt) },
    { header: 'Last Updated', accessor: 'updatedAt', render: (row) => formatDate(row.updatedAt) }
  ];

  return (
    <div className="application-list">
      <div className="application-list__controls">
        <input 
          type="text" 
          placeholder="Search by name or email..." 
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        
        <select 
          className="status-filter"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="">All Statuses</option>
          <option value="INVITED">Invited</option>
          <option value="CONSENT_PENDING">Consent Pending</option>
          <option value="IN_PROGRESS">In Progress</option>
          <option value="SUBMITTED">Submitted</option>
          <option value="VERIFICATION_IN_PROGRESS">Verification In Progress</option>
          <option value="REPORT_READY">Report Ready</option>
          <option value="COMPLETED">Completed</option>
        </select>
      </div>

      <DataTable 
        columns={columns} 
        data={filteredApplications} 
        loading={loading}
        emptyMessage="No applications found matching your criteria."
      />
    </div>
  );
};

export default ApplicationList;
